import { Edit } from '@carbon/icons-react';
import { colorTextAccent } from 'component/color';
import { CLICK, componentWithVariants, demoFile, HOVER, story, variant } from 'system/demo';

import { ActionButtonWithDisabledState } from '../button';

demoFile('open-modules/zdf/component/button', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=6295-32864&t=6X5Yru9KViifgAan-0',
});

const onPress = () => {};

function ActionButtonWithDisabledStateDemo(props) {
    return <ActionButtonWithDisabledState {...props} onPress={onPress} text='Press me' />;
}

componentWithVariants('Action Button With Disabled State', ActionButtonWithDisabledStateDemo, {}, [
    variant('Default', {}, [story('Hover', [HOVER('Press me')]), story('Press', [CLICK('Press me')])]),
    variant(
        'Icon',
        {
            args: { icon: Edit },
        },
        [story('Hover', [HOVER('Press me')]), story('Press', [CLICK('Press me')])],
    ),
    variant(
        'Text color',
        {
            args: { icon: Edit, textColor: colorTextAccent },
        },
        [story('Hover', [HOVER('Press me')]), story('Press', [CLICK('Press me')])],
    ),
    variant('Disabled', {
        args: { icon: Edit, disabled: true },
    }),
]);
